import { getEmployeesAPI } from "../../../Redux/Apis/employeeApi";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PageContainerHeader from "../../molecules/PageContainerHeader/PageContainerHeader";
import EmployeeListContainer from "../../molecules/EmployeeListContainer/EmployeeListContainer";
import { setEmployeePagination } from "../../../Redux/Slices/employeeSlice";
import EmployeeDetailDrawer from "../../molecules/EmployeeDetailDrawer/EmployeeDetailDrawer";
import {
  checkPermission,
  permissionType,
} from "../../../app/utils/common/Functions";
import "./EmployeesPage.scss";

const EMPLOYEE_TABS = [
  { key: "active", label: "Active Employees", filterBy: "active" },
  { key: "ex", label: "Ex-Employees", filterBy: "deleted" },
];

const EmployeesPage = () => {
  const dispatch = useDispatch();
  const {
    employees: profile,
    pagination,
    loading,
    isDataUpdated,
  } = useSelector((state) => state.employee);
  const [activeTab, setActiveTab] = useState("active");
  const [isCreateOpen, setIsCreateOpen] = useState(false);
  const [profilePerPage] = useState(10);
  const [searchString, setSearchString] = useState("");
  const [searchResult, setSearchResult] = useState([]);

  const activeFilterBy =
    EMPLOYEE_TABS.find((tab) => tab.key === activeTab)?.filterBy || "active";
  const isExEmployeeView = activeTab === "ex";

  const fetchProfile = useCallback(
    (page, filterBy = activeFilterBy) => {
      dispatch(getEmployeesAPI({ page, limit: 10, filterBy }));
    },
    [dispatch, activeFilterBy]
  );

  useEffect(() => {
    if (!loading) fetchProfile(pagination.currentPage, activeFilterBy);
  }, [pagination.currentPage, activeFilterBy]);

  useEffect(() => {
    if (isDataUpdated) fetchProfile(pagination.currentPage, activeFilterBy);
  }, [isDataUpdated, fetchProfile, pagination.currentPage, activeFilterBy]);

  // Search By Name and Email
  const onChangeSearch = (search = "") => {
    // const searchData = profile.filter((cat, index) => {
    //     if (cat.title?.toLowerCase().includes(search?.toLowerCase()) || cat.body?.toLowerCase().includes(search?.toLowerCase())) {
    //         return cat;
    //     }
    // });
    // setSearchResult(searchData);
    // setSearchString(search);
    // setCurrentPage(1);
    // setActivePage(1);
  };

  const onPressCancelSearch = () => {
    setSearchString("");
    setSearchResult([]);
    dispatch(
      setEmployeePagination({
        ...pagination,
        currentPage: 1,
      })
    );
  };

  // Calculate Profile Range
  const getProfileRange = (currentPage, profilePerPage, totalProfile) => {
    const start = (currentPage - 1) * profilePerPage + 1;
    const end = Math.min(currentPage * profilePerPage, totalProfile);
    return `${start} - ${end}`;
  };

  const dataToDisplay = searchString ? searchResult : profile;

  const pageNumbers = [];
  const totalProfile = pagination.totalData;
  const sumOfProfile = Math.ceil(totalProfile / profilePerPage);
  const profileRange = getProfileRange(
    pagination.currentPage,
    profilePerPage,
    totalProfile
  );

  const currentProfile = dataToDisplay;

  for (let i = 1; i <= sumOfProfile; i++) {
    pageNumbers.push(i);
  }

  const handleTabChange = (tabKey) => {
    if (tabKey === activeTab) return;
    setActiveTab(tabKey);
    setSearchString("");
    setSearchResult([]);
    dispatch(
      setEmployeePagination({
        ...pagination,
        currentPage: 1,
      })
    );
  };

  const handlePageLink = (event, number) => {
    event.preventDefault();
    dispatch(setEmployeePagination({ ...pagination, currentPage: number }));
  };

  const prevPage = (event) => {
    event.preventDefault();
    if (pagination.currentPage > 1 && !loading) {
      dispatch(
        setEmployeePagination({
          ...pagination,
          currentPage: pagination.currentPage - 1,
        })
      );
    }
  };

  const nextPage = (event) => {
    event.preventDefault();
    if (pagination.currentPage + 1 <= pagination.totalPages && !loading) {
      dispatch(
        setEmployeePagination({
          ...pagination,
          currentPage: pagination.currentPage + 1,
        })
      );
    }
  };
  return (
    <div className="employees-page">
      <div className="employees-page__intro">
        <h1 className="page-title">Employee Master List</h1>
        <p className="page-subtitle">Track employees, manage directory data, and maintain attendance mappings.</p>
      </div>
      <PageContainerHeader
        title={isExEmployeeView ? "Ex-Employees" : "Employees"}
        button={
          !isExEmployeeView &&
          checkPermission(permissionType.USER_MANAGEMENT, "create")
        }
        buttonTitle="Add"
        onclickDrawer={() => setIsCreateOpen(true)}
      />

      <nav className="employees-tabs" aria-label="Employee list sections">
        {EMPLOYEE_TABS.map((tab) => (
          <button
            key={tab.key}
            type="button"
            className={`employees-tab ${activeTab === tab.key ? "active" : ""}`}
            onClick={() => handleTabChange(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </nav>

      {isExEmployeeView && (
        <p className="employees-page__ex-hint">
          Employees removed from the active list appear here with their exit details.
        </p>
      )}

      <EmployeeListContainer
        key={activeTab}
        profile={currentProfile}
        loading={loading}
        pageNumbers={pageNumbers}
        totalProfile={totalProfile}
        handlePageLink={handlePageLink}
        prevPage={prevPage}
        nextPage={nextPage}
        activePage={pagination.currentPage}
        profileRange={profileRange}
        searchResult={searchResult}
        onChangeSearch={onChangeSearch}
        onPressCancelSearch={onPressCancelSearch}
        searchString={searchString}
        variant={isExEmployeeView ? "ex" : "active"}
      />
      {isCreateOpen && (
        <EmployeeDetailDrawer
          isEditOpen={isCreateOpen}
          toggleDetailDrawer={() => setIsCreateOpen((pre) => !pre)}
        />
      )}
    </div>
  );
};

export default EmployeesPage;
